import { render, staticRenderFns } from "./ImageNewsConfig.vue?vue&type=template&id=309e8ff2"
import script from "./ImageNewsConfig.vue?vue&type=script&lang=js"
export * from "./ImageNewsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports